<template>
  <div class="column is-6">
    <div class="card height-100">
      <header class="header-card">
        <p> {{ $t('societes.fonctionnalitesFacultatives.title') }} </p>
      </header>
      <div class="card-content">
        <div class="columns">
          <div class="column is-6">
            <b-field :label="$t('societes.fonctionnalitesFacultatives.baf')">
              <qd-switch v-model="societe.activerBonAFacturer" class="mgt-5px">
              </qd-switch>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field :label="$t('societes.fonctionnalitesFacultatives.valeurDefaut')">
              <b-select v-model="societe.bonAFacturer">
                <option :value="true"> {{ $t('general.oui') }}
                </option>
                <option :value="false"> {{ $t('general.non') }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'gestionBonAFacturer',
  props: {
    societe: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style scoped>

</style>
